<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统功能</el-breadcrumb-item>
        <el-breadcrumb-item>IP黑名单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog()" >新增IP</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="ip_addr"
            label="IP地址">
          </el-table-column>
          <el-table-column
            align="center"
            label="添加时间">
            <template slot-scope="scope">
              <div>{{ scope.row.create_time | formatDate}}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="编辑内容"
            width="240">
            <template slot-scope="scope" >
              <el-popconfirm
                confirmButtonText='确定'
                cancelButtonText='返回'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddVisible" :close-on-click-modal="false" width="900px" class="padding_10">
      <el-form :model="addForm"  :rules="addRules" label-width="120px"  ref="addForm">
        <el-form-item label="IP地址" prop="ip_addr" >
          <el-input v-model="addForm.ip_addr" auto-complete="off" placeholder="请输入IP地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="addLoading" @click="add()">保 存</el-button>
        <el-button size="small" @click="callOf()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addIp, delIp, getList} from '../../api/ip_black'

export default {
  data () {
    return {
      page_size: 50,
      page: 1,
      total: 0,
      tableData: [],
      dialogTitle: '',
      dialogAddVisible: false,
      addForm: {
        ip_addr: ''
      },
      addRules: {
        ip_addr: [
          { required: true, message: '请输入IP地址', trigger: 'blur' }
        ]
      },
      addLoading: false
    }
  },
  mounted () {
    this.setTableData()
  },
  methods: {
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 每页数据数切换
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 删除
    del (id) {
      delIp({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 添加弹窗
    addDialog () {
      this.dialogAddVisible = true
      this.dialogTitle = '添加IP白名单'
    },
    // 表格数据填充
    setTableData () {
      getList({
        page: this.page,
        page_size: this.page_size
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.tableData = res.data.table_list
          this.total = res.data.total
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 关闭弹窗
    callOf () {
      this.dialogAddVisible = false
      this.$refs['addForm'].resetFields()
    },
    // 添加
    add () {
      this.addLoading = true
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          addIp({
            ip_addr: this.addForm.ip_addr
          }).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogAddVisible = false
              this.$refs['addForm'].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
      this.addLoading = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ip_black/index.vue